import { Injectable } from '@angular/core';
import { Api } from '../api/api';

import { NoticeSetting } from '../../models/notice-setting';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';

@Injectable()
export class NoticeSettingProvider {
  url: string = 'notice_settings';

  constructor(public api: Api) {
  }

  load(): Observable<NoticeSetting> {
    return this.api.get(this.url).map(data => new NoticeSetting(data));
  }

  updateToggle(id, key): Observable<any> {
    return this.api.put(this.url + '/' + id, {
      id: id,
      setting: key
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/notice-setting/notice-setting.ts